import { render, staticRenderFns } from "./AiCustomCheckbox.vue?vue&type=template&id=7471fc63&scoped=true"
import script from "./AiCustomCheckbox.vue?vue&type=script&lang=ts"
export * from "./AiCustomCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./AiCustomCheckbox.vue?vue&type=style&index=0&id=7471fc63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471fc63",
  null
  
)

export default component.exports